import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '../../component-base';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthForignerService } from 'src/app/shared/services/authentication/authforigner.service';
import { LoginforignerDto } from 'src/app/shared/models/loginforigner.model';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from 'src/app/shared/services/cashe-service';

@Component({
  selector: 'app-loginusingforigner',
  templateUrl: './loginusingforigner.component.html',
  styleUrls: ['./loginusingforigner.component.css']
})
export class LoginusingforignerComponent extends BaseComponent{
  form: FormGroup;

  constructor(private formBuilder: FormBuilder,
    public router: Router,
    private authservice:AuthForignerService,
    public translate: TranslateService)
  {
    super();
  }

  ngOnInit() {   
    this.initForm();
  }
  initForm() {
    this.form = this.formBuilder.group({
      email: ['',Validators.required],     
      password: ['',Validators.required]      
    },
    );
  }
  register(){
    this.router.navigate(['/register']);
  }
  verify(){
    this.router.navigate(['/verifyotp']);
  }

 

  login(){
    let login:LoginforignerDto=new LoginforignerDto();
    login.email = this.form.controls["email"].value;
    login.password = this.form.controls["password"].value;
    this.authservice.Login(login).subscribe(result=>{
      if(result.value.value !="")
      {
        CacheService.setToken(result.value.value);
        CacheService.setUsername(login.email);
        // CacheService.setUserId(login.id);
        this.router.navigate(['']);
        location.href = '/';
      }
      else 
      {
        this.failed(this.translate.instant('shared.loginfailed'));
      }
      
    });

  }
}
